import type { PermissionMap, PermissionDTO, PermissionAction } from '~/types/permissions'

const ALLOWED_ACTIONS = new Set([
  'list',
  'show',
  'store',
  'update',
  'delete',
  'deploy',
  'manage-users',
  'op_action',
  'conf_action',
  'admin_action',
  'debug_action',
  'resolved'
])

// Map backend action names to the canonical frontend action names.
// The backend emits snake_case for some actions (e.g. `manage_users`) while the
// frontend standardizes on the hyphenated form (`manage-users`) used throughout
// `can('license', 'manage-users')` guards, the sidebar, and page middleware.
const ACTION_ALIASES: Record<string, PermissionAction> = {
  manage_users: 'manage-users'
}

export const normalizePermissions = (dto: PermissionDTO): PermissionMap => {
  const normalized: PermissionMap = {}
  const unhandledActions: string[] = []

  for (const [container, actions] of Object.entries(dto)) {
    const allowedActions = actions
      .map((action) => ACTION_ALIASES[action] ?? action)
      .filter((action) => {
        if (ALLOWED_ACTIONS.has(action)) return true
        unhandledActions.push(action)
        return false
      })

    if (allowedActions.length > 0) {
      normalized[container] = allowedActions as readonly PermissionAction[]
    }
  }

  if (unhandledActions.length > 0) {
    const unique = [...new Set(unhandledActions)]
    console.warn(
      `[Permissions] Unhandled actions from backend: ${unique.join(', ')}. ` +
        'Add to ALLOWED_ACTIONS in utils/permissions/gate.ts to enable.'
    )
  }

  return normalized
}
